import * as React from 'react';
import { IconProps } from './IconProps';
import { White } from '@traceair/tds';

const CloseTinyIcon = ({ color = White, size = '24' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.6503 9.41855C7.16214 8.9304 7.16214 8.13894 7.6503 7.65078C8.13845 7.16263 8.92991 7.16263 9.41806 7.65078L11.9979 10.2307L14.577 7.65154C15.0652 7.16338 15.8567 7.16338 16.3448 7.65154C16.833 8.13969 16.833 8.93115 16.3448 9.4193L13.7657 11.9984L16.344 14.5768C16.8322 15.0649 16.8322 15.8564 16.344 16.3445C15.8559 16.8327 15.0644 16.8327 14.5763 16.3445L11.9979 13.7662L9.41883 16.3453C8.93067 16.8334 8.13922 16.8334 7.65106 16.3453C7.16291 15.8571 7.16291 15.0657 7.65106 14.5775L10.2302 11.9984L7.6503 9.41855Z"
      fill={color}
    />
  </svg>
);

export default CloseTinyIcon;
